import React, { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import QrScanner from "../ui/QrScanner.jsx";
import { scanTarget } from "../scanTarget";
import "../mobile.css";

// The Scan tab: scan a traveler or bin label inside the app (a phone's own camera app opens
// the link in Safari instead, whose sign-in is separate). Traveler codes go through the same
// /s/:code resolver a phone camera or a USB scanner uses (pages/ScanResolvePage.jsx).
export default function ScanScreen() {
  const navigate = useNavigate();
  const [typed, setTyped] = useState("");
  const [message, setMessage] = useState(null);

  const handle = useCallback((text) => {
    const t = scanTarget(text);
    if (t.navigate) {
      setMessage(null);
      navigate(t.navigate);
    } else {
      setMessage(t.message);
    }
  }, [navigate]);

  return (
    <div className="jq-screen" data-testid="scan-screen">
      <QrScanner onScan={handle} />
      {message && <div className="alert alert-warning mt-3" role="alert">{message}</div>}
      <form
        className="jq-scan-manual"
        onSubmit={(e) => {
          e.preventDefault();
          if (typed.trim()) handle(typed);
        }}
      >
        <label htmlFor="scan-typed" className="form-label">Or type the code</label>
        <div className="jq-row">
          <input
            id="scan-typed"
            className="form-control"
            value={typed}
            onChange={(e) => setTyped(e.target.value)}
            placeholder="task-37114 or job-812"
            autoCapitalize="none"
            autoCorrect="off"
            spellCheck={false}
            enterKeyHint="go"
          />
          <button type="submit" className="btn btn-primary" disabled={!typed.trim()}>Go</button>
        </div>
      </form>
    </div>
  );
}
